export class ContainerYard {
    id: number;
    code: string;
    description: string;
    status: string;
    createdAt: string;
    updatedAt: string;
}